import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RequestProceduresService } from 'src/app/services/request-procedures.service';

@Component({
  selector: 'app-requests-procedures-detail-request',
  templateUrl: './requests-procedures-detail-request.component.html',
  styleUrls: ['./requests-procedures-detail-request.component.scss'],
  providers: [DatePipe],
})
export class RequestsProceduresDetailRequestComponent implements OnInit {
  @Input() data: string;
  id: number;
  typeId: any;
  data_: any;
  dataForm: FormGroup;
  dataSource: any = [];
  dataSourceHistory: any = [];
  dataSource_: any = [];
  dataSourceHistory_: any = [];
  allRegister: any;
  allRegisterHistory: any;
  public typeView = '' //register-request  method-pay  //declaration-studies
  displayedColumns: string[] = ['download', 'file', 'dateRegister'];
  displayedColumnsHistory: string[] = ['status', 'comment', 'statusDate'];
  public pageSize: number = 5;

  constructor(
    private activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private dateTime: DatePipe,
    private serviceRequestProcedures: RequestProceduresService,
  ) {
  }

  public setTypeView():string{
    let dataReturn = ''
    switch(this.typeId){
      case 7: //fallecimiento
        this.typeView = ''
        break;
      case 8:  //register-request
        this.typeView = 'register-request'
        break;
      case 9:  //method-pay
        this.typeView = 'method-pay'
        break;
      case 10: //declaration-studies
        this.typeView = 'declaration-studies'
        break;
      case 11: //
        this.typeView = ''
        break;
      case 12: 
        this.typeView = ''
        break;
      case 13: //
        this.typeView = ''
        break;
      default:
        this.typeView = ''
    }

    return dataReturn
  }

  ngOnInit(): void {
    const build = this.data.replace(/'/g, `"`);
    this.data_ = JSON.parse(build);
    this.createForm();
    this.getFiles(this.id);
    this.getHistory(this.id);
  }

  private createForm(): any {
    this.dataForm = this.fb.group({
      name: [this.data_.name],
      secondname: [this.data_.secondname],
      lastname: [this.data_.lastname],
      secondlastname: [this.data_.secondlastname],
      document: [this.data_.document],
      birthday: [this.convertDate(this.data_.birthday)],
      nameDecla: [this.data_.nameDecla],
      secondnameDecla: [this.data_.secondnameDecla],
      lastnameDecla: [this.data_.lastnameDecla],
      secondlastnameDecla: [this.data_.secondlastnameDecla],
      documentDecla: [this.data_.documentDecla],
      birthdayDecla: [this.convertDate(this.data_.birthdayDecla)],
      phoneDecla: [this.data_.phoneDecla],
      emailDecla: [this.data_.emailDecla],
      numberPolicy: [this.data_.numberPolicy],
      nameBank: [this.data_.nameBank],
      typeCta: [this.data_.typeCta],
      numberCta: [this.data_.numberCta],
      numberCtaCCI: [this.data_.numberCtaCCI],
      currency: [this.data_.currency],
      nameBenef: [this.data_.nameBenef],
      secondnameBenef: [this.data_.secondnameBenef],
      lastnameBenef: [this.data_.lastnameBenef],
      secondlastnameBenef: [this.data_.secondlastnameBenef],
      typeCtaBenef: [this.data_.typeCtaBenef],
      birthdayBenef: [this.convertDate(this.data_.birthdayBenef)],
      address: [this.data_.address],
      typePension: [this.data_.typePension],
      gender: [this.data_.gender],
      invalidBeneficiary: [this.data_.invalidBeneficiary],
      // documentBenef: [this.data_.documentBenef],
      nroDocBenef: [this.data_.nroDocBenef],
      affiliaterelationship: [this.data_.affiliaterelationship],
    });
  }

  private getFiles(id: number): void {
    this.serviceRequestProcedures.getFiles(id).subscribe(
      (file: any) => {
        this.allRegister = file.length;
        this.dataSource_ = file;
        this.dataSource = new MatTableDataSource(file.slice(5 * 0, this.pageSize * (0 + 1)));
      }
    )
  }

  private getHistory(id: number): void {
    this.serviceRequestProcedures.getHistory(id).subscribe(
      (file: any) => {
        this.allRegisterHistory = file.length;
        this.dataSourceHistory_ = file;
        this.dataSourceHistory = new MatTableDataSource(file.slice(5 * 0, this.pageSize * (0 + 1)));
      }
    )
  }

  public downloadFile(file: any): void {
    window.open(file, "_blank")
  }

  private convertDate(date: Date): string {
    return this.dateTime.transform(date, "dd/MM/yyyy");
  }

  onPageFired(event): any {
    this.dataSource = new MatTableDataSource(this.dataSource_.slice(5 * event.pageIndex, this.pageSize * (event.pageIndex + 1)));
  }

  onPageFiredHistory(event): any {
    this.dataSourceHistory = new MatTableDataSource(this.dataSourceHistory_.slice(5 * event.pageIndex, this.pageSize * (event.pageIndex + 1)));
  }

  onNoClick(): void {
    this.activeModal.close();
  }
}
